import { useDemoMarket, Sparkline } from "./MarketTape";

export const MarketPanel = () => {
  const { rows, label } = useDemoMarket();
  return (
    <div data-testid="hero-market-panel" className="card p-4 sm:p-5 shadow-2xl shadow-black/50 relative overflow-hidden">
      <div className="absolute inset-0 grid-bg opacity-60 pointer-events-none" />
      <div className="relative flex items-center justify-between mb-4">
        <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-slate-400">Market Watch</span>
        <span data-testid="hero-market-demo-label" className="chip !text-[10px] !py-0.5 border-amber-400/30 text-amber-300 bg-amber-400/5">{label}</span>
      </div>
      <ul className="relative divide-y divide-white/5">
        {rows.map((r) => (
          <li key={r.symbol} data-testid={`hero-ticker-${r.symbol.toLowerCase().replace(/[^a-z0-9]/g, "")}`} className="grid grid-cols-[1fr_auto_auto] items-center gap-4 py-2.5">
            <div><p className="font-mono text-xs text-slate-300">{r.symbol}</p><p className="font-mono text-base text-slate-50 tabular-nums">{r.price}</p></div>
            <Sparkline pts={r.pts} up={r.chg >= 0} />
            <span className={`font-mono text-xs tabular-nums w-16 text-right ${r.chg >= 0 ? "up" : "down"}`}>{r.chg >= 0 ? "+" : ""}{r.chg.toFixed(2)}%</span>
          </li>
        ))}
      </ul>
      <p className="relative mt-3 text-[10px] text-slate-500">Simulated values for design illustration only. Not live quotes. Not a recommendation.</p>
    </div>
  );
};
